import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { usePageMeta } from "../hooks/usePageMeta";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Login() {
  usePageMeta("Accedi | Costruzioni Ciosko", "Accedi con il tuo account Google all'area riservata di Costruzioni Ciosko.");
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/", { replace: true });
  }, [user, loading, navigate]);

  return (
    <section className="relative min-h-screen flex items-center justify-center px-5 overflow-hidden">
      <img src="/images/hero.jpg" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-base/80 via-base/90 to-base" aria-hidden="true" />
      <div data-testid="login-card" className="relative w-full max-w-md bg-card/95 backdrop-blur border border-steel p-8 sm:p-10 text-center">
        <img src="/images/logo-light.png" alt="Costruzioni Ciosko" className="h-20 w-auto mx-auto" />
        <h1 className="font-display font-bold text-2xl text-white uppercase tracking-tight mt-8">Area riservata</h1>
        <p className="text-cement text-sm leading-relaxed mt-4">
          Accedi con Google per entrare nel pannello di gestione del sito.
        </p>
        <button data-testid="google-login-button" onClick={login} className="btn-primary w-full mt-8">
          <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z"/></svg>
          Continua con Google
        </button>
        <p className="flex items-start gap-2.5 text-[11px] text-cement/80 leading-relaxed text-left mt-6 border border-steel bg-graphite px-4 py-3">
          <ShieldCheck size={15} className="text-forest-glow shrink-0 mt-0.5" />
          L'accesso al pannello di amministrazione è riservato alle email autorizzate dal proprietario (costruzioniciosko@gmail.com).
        </p>
        <Link to="/" data-testid="login-back-home" className="inline-flex items-center gap-2 text-xs text-cement hover:text-forest-glow transition-colors mt-6 uppercase tracking-[0.14em] font-semibold">
          <ArrowLeft size={14} /> Torna al sito
        </Link>
      </div>
    </section>
  );
}
